module.exports = __webpack_public_path__ + "static/media/bfile-mfg.f17ae8af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-mfg.svg
// module id = 204
// module chunks = 0